import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import './useNetworkStatus.css'

const OfflinePage = (props) => {
  const [data, setData] = useState([]);
  const openDB = () => {
    const request = indexedDB.open("DNA_Pathogen_Tracker", 1);
    request.onsuccess = (event) => {
      event.preventDefault();
      const db = event.target.result;
      const txn = db.transaction("org_sample", "readonly");
      const objectStore = txn.objectStore("org_sample");
      let contacts = [];
      objectStore.openCursor().onsuccess = (event) => {
        let cursor = event.target.result;
        if (cursor) {
          let contact = cursor.value;
          contacts.push(contact);
          cursor.continue();
        }
        // close the database connection
        txn.oncomplete = function () {
          setData(contacts);
          db.close();
        };
        return cursor;
      };
     return txn;
    };
  };
  useEffect(() => {
    openDB();
  }, []);

  const generateTable = () => {
    return data.map((record) => {
      return <p className='offline-sample'>
          <table className="offline-table">
              <tr><th>Organism:</th><td>{(JSON.stringify(record.organism)).replace(/"/g, "")}</td></tr>
              <tr><th>Location:</th><td>{(JSON.stringify(record.location)).replace(/"/g, "")}</td></tr>
              <tr><th>Date and Time:</th><td>{((JSON.stringify(record.date_time)).replace(/"/g, ""))}</td></tr>
              <tr><th>Comments:</th><td>{(JSON.stringify(record.comments)).replace(/"/g, "")}</td></tr>
              <tr><th>Type of Analysis:</th><td>{(JSON.stringify(record.type_of_analysis)).replace(/"/g, "")}</td></tr>
              <tr><th>Type of Samples:</th><td>{(JSON.stringify(record.type_of_samples)).replace(/"/g, "")}</td></tr>
              <tr><th>Barcode:</th><td>{(JSON.stringify(record.barcode)).replace(/"/g, "")}</td></tr>
              <tr><th>Refernece Genome:</th><td>{(JSON.stringify(record.reference_genome)).replace(/"/g, "")}</td></tr>
              <tr><th>Images:</th><td>{(JSON.stringify(record.picture)).replace(/"/g, "")}</td></tr>
            </table>
        </p>;
    });
  };

  return (
    <div>
    <h3 className="offline-saved-header">Here is your offline saved data</h3>
      {window.innerWidth<800 && 
      <div className="offline-header">
      <Link className="offline-to-home" to='/offlinePage'>Offline</Link>
      <Link className="offline-to-home" to='/'>Home</Link>
      </div>
      }
      {generateTable()}
      
    </div>
  );
};
export default OfflinePage;
